module.exports = __webpack_public_path__ + "static/logo-fonnor-774bdc3c71b9ae961ebd01c1e602b391.svg";